import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="main"
        className="main-content main-content--page main-content--page--margin"
      >
        <div className="shopify-section">
          <div className="page-title">
            <h1>ABOUT Margotal</h1>
          </div>
          <div className="about-content">
            <h2>THE BRAND</h2>
            <p>
              Margotal is a British designer whose work is characterised by a
              commitment to quality, function and timeless design. Since
              establishing her eponymous label in 1970, she has built a
              reputation for creating clothes that transcend age, body shape and
              gender.
            </p>
            <p>
              The Margotal aesthetic is rooted in an appreciation for
              traditional British craftsmanship and natural materials. Each
              garment is designed with longevity in mind, using high-quality
              fabrics and construction techniques that ensure pieces can be worn
              season after season.
            </p>

            <h2>DESIGN PHILOSOPHY</h2>
            <p>
              Margotal's design philosophy centres on simplicity, practicality
              and understated elegance. The collections feature clean lines,
              relaxed proportions and a muted colour palette that reflects a
              distinctly British sensibility.
            </p>
            <p>
              Every piece is designed to be versatile and wearable, with an
              emphasis on comfort and ease of movement. The brand champions a
              considered approach to dressing, favouring investment pieces over
              fast fashion trends.
            </p>

            <h2>MATERIALS & CRAFTSMANSHIP</h2>
            <p>
              A deep respect for traditional craftsmanship underpins every
              Margotal collection. The brand works with specialist mills and
              factories across Britain and Europe, many of which have been
              producing fabrics and garments for generations.
            </p>
            <p>
              Natural fibres are favoured throughout the collections, including
              cotton, wool, linen and silk. These materials are chosen for their
              durability, breathability and ability to age gracefully over time.
            </p>

            <h2>MHL.</h2>
            <p>
              MHL. is the contemporary diffusion line of Margotal, offering more
              accessible price points whilst maintaining the brand's commitment
              to quality and design integrity. The line features relaxed,
              everyday pieces in durable fabrics, perfect for building a
              functional wardrobe.
            </p>

            <h2>SUSTAINABILITY</h2>
            <p>
              Margotal has always prioritised sustainable practices, focusing on
              creating garments that last. The brand's approach to
              sustainability encompasses responsible sourcing, ethical
              manufacturing, and a commitment to reducing waste throughout the
              production process.
            </p>
            <p>
              By designing timeless pieces that transcend seasonal trends, the
              brand encourages customers to invest in fewer, better-quality
              items that can be worn for years to come.
            </p>

            <h2>SHOPS & SPACES</h2>
            <p>
              Margotal shops are designed to reflect the brand's aesthetic
              values, featuring clean, minimal interiors that showcase the
              clothes and create a calm shopping environment. Many stores also
              feature carefully curated selections of homeware, books and
              lifestyle objects that complement the brand's design ethos.
            </p>
            <p>
              The flagship store on Wigmore Street in London also hosts regular
              exhibitions celebrating British design, craft and creativity.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default About;
